import { Pipe, PipeTransform } from '@angular/core';
import { Helpers } from '@app/helpers/helpers.class';

@Pipe({ name: 'readableTimeSpan' })
export class ReadableTimeSpanPipe implements PipeTransform {
    transform(minutes: number): string {
        return Helpers.toReadableTimeSpan(minutes);
    }
}
